<template>
  <div>

  <div data-v-sticky-container>

    <section class="hero is-info is-bold">
      <div class="hero-body">
        <div class="container has-text-centered">
          <span>
            <font-awesome-icon icon="map-signs" size="2x" />
            <h1 class="title is-3">expedijob : offres d'emploi 100% télétravail</h1>
              <p align="right">
                <button class="button is-primary is-medium is-rounded" @click="$router.push('publierjob')">
                  espace recruteurs : publier un job 
                </button>
              </p>
          </span>
        </div>
      </div>
    </section>

    <section class="section">

    <div class="container">  

    <p class="content is-medium has-text-centered has-text-primary">
        <strong>POUR TROUVER UN JOB EN DEUX CLICS :</strong>
    </p>

     <div class="box">

            <span class="tag is-light is-medium">
              <p> 
                1- Sélectionner par catégories de job
              </p>
            </span>
       
            <b-field grouped group-multiline>
            <!-- multiline parameter is for responsive multiline on mobile device -->
            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="informatique"
                type="is-success">
                informatique
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="fico"
                type="is-success">
                comptabilité et gestion
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="vente"
                type="is-success">
                commercial
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="rh"
                type="is-success">
                ressources humaines
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="creatif"
                type="is-success">
                créatif
            </b-checkbox-button>
            </b-field>

            <b-field expanded>
            <b-checkbox-button v-model="checkboxGroup"
                native-value="divers"
                type="is-success">
                autre
            </b-checkbox-button>
            </b-field>

            </b-field>
            
      </div> 

      <div class="box">

        <span class="tag is-light is-medium">
          <p> 
            2- Cliquer pour mettre à jour
          </p>
        </span>

        <!-- container with 1 left and 1 right side -->
        <nav class="level">
          <!-- Left side -->
          <div class="level-left">
            <div class="level-item">

            <div class="field has-addons">
              <p class="control">
                <a class="button is-warning is-medium is-focused" v-on:click="getJobDisp" :disabled="loading">
                  <span>
                    <font-awesome-icon icon="paw" size="2x"/>
                  </span>
                   <span>-  afficher les résultats</span>
                </a>
              </p>
            </div> 

            </div> 
          </div>
          <!-- Right side -->
          <div class="level-right">   
            <div class="level-item">
              <label for="filtername"><font-awesome-icon icon="arrow-alt-circle-right" /> chercher des annonces contenant le mot-clé = </label>
              <input v-model="findName" id="filtername" type="text" />
            </div>
          </div>
        </nav>
      </div> 

      <p align="right">
          <a v-bind:href="apiUrl + '/apropos'">
            <img src="../assets/expedijob.png" alt="Job télétravail présentation" height="355" width="260">
          </a>
      </p>
      
       <h3 class="title">Liste d'offres d'emploi avec télétravail</h3>

       <div v-if="loading" class="box">
          <font-awesome-icon icon="spinner" class="fa-spin" size="3x"  />
       </div> 

        <div v-if="noresult == 'yes'" class="tag is-light is-medium">
            <p> 
              <br /> 
                <b>Pas de résultat pour le moment</b> - essayez d'autres critères de sélection
              <br /> 
            </p>
        </div> 


        <table class="table is-striped is-fullwidth is-hoverable">
          <thead>
                <tr>
                 <th>Titre</th>
                  <th class="content is-hidden-mobile">Entreprise</th>
                  <th class="content is-hidden-mobile">Date</th>
                </tr>  
          </thead>

          <tbody v-for="(jobres, index) in tablejobdisp" :key="index">   

            <template v-if="jobres.tableorigin == 'jobfree'">
              <tr @click="jobres.sublineVisible = !jobres.sublineVisible">  
                <td>{{ jobres.title }}</td>
                <td class="content is-hidden-mobile">{{ jobres.company }}</td>
                <td class="content is-hidden-mobile">{{ jobres.timediff }}</td>
              </tr>
            </template>

            <template v-if="jobres.tableorigin == 'premium'">
              <tr>
                <td>
                  <a v-bind:href="jobres.url" target="_blank">{{jobres.title}}</a>                  
                </td>
                <td class="content is-hidden-mobile">
                  <a v-bind:href="jobres.url" target="_blank">{{jobres.company}}</a>
                </td>
                <td class="content is-hidden-mobile">{{ jobres.timediff }}</td>
              </tr>
            </template>

            <template v-if="jobres.linedisabled">
                <tr>
                  <td>
                    <div v-html="surlinema(jobres.title)"></div>
                  </td>
                  <td class="content is-hidden-mobile">{{ jobres.company }}</td>
                  <td class="content is-hidden-mobile">{{ jobres.timediff }}</td>
              </tr>
            </template>

            <template v-if="jobres.sublineVisible"> 
              <tr>
                <td colspan="3" class="content has-background-success">
                   <div class="content is-hidden-tablet">
                      <p>
                      Annonce publiée il y a {{ jobres.timediff }}
                      </p>
                      <br/>
                  </div>
                  <div class="pre-formatted">
                    <div v-html="matchName(jobres.description)"></div>
                  </div>

                  <div v-if="jobres.source === 'poleemploi'">
                    <figure class="image is-128x128">
                      <img src="../assets/1-logo-poleemploi.png">
                    </figure>
                  </div>

                   <div v-if="jobres.source === 'monster'">
                      <p>
                      Annonce du site d'emploi Monster
                      </p>
                      <br/>
                  </div>

                  <div v-if="jobres.source === 'indeed'">
                      <p>
                      Annonce du site indeed
                      </p>
                      <br/>
                  </div>

                  <div v-if="jobres.source === 'codeur'">
                      <p>
                      Annonce vue sur le site Codeur.com
                      </p>
                      <br/>
                  </div>

                  <div v-if="jobres.source === 'lesjeudis'">
                      <p>
                      Annonce vue sur le site LesJeudis
                      </p>
                      <br/>
                  </div>

                  <div v-if="jobres.source === 'apec'">
                      <p>
                      Annonce du site Apec
                      </p>
                      <br/>
                  </div>

                  <div v-if="jobres.jobhours === 'full'">
                  Temps plein
                  </div>
                  <div v-else-if="jobres.jobhours === 'flexible'">
                    Temps partiel
                  </div>
                  <div v-else>
                    {{ jobres.jobhours }}
                  </div>
                  <br />        

                  <a v-bind:href="jobres.url" target="_blank" class="button is-link">
                    Postuler
                  </a>
                  <br />   

                  <div align="right">
                  <font-awesome-icon icon="chevron-circle-up" @click="jobres.sublineVisible = !jobres.sublineVisible" />
                  </div>

                </td> 
               </tr>
             </template>
          </tbody>
        </table> 

      </div>

      <div v-if="noselection">
         <p class="control">
            <a class="button is-warning is-focused" v-on:click="getJobDisp" :disabled="loading">
               <span><font-awesome-icon icon="paw"/></span>
                <span>-  afficher plus de lignes</span>
            </a>
         </p>
      </div> 
    </section>

     <div v-sticky sticky-offset="offset" sticky-side="bottom">
        <section>
         <b-message title="Recevez des offres de job télétravail... Personnalisées pour vous !" :active.sync="isActive" aria-close-label="Fermer">
            En vous inscrivant aux emails d'information du site 
          <div class="field">
            <input type="email" class="input" name="email" placeholder=" - Votre email ici - " v-model="email">
          </div>

          <form id="signup-form" @submit.prevent="processForm">
            <div class="field has-text-right">
             <button type="submit" class="button is-primary">Recevoir des jobs</button>
            </div>
          </form>                       
            </b-message>
        </section>
      </div>

    <footer class="footer">
        <nav class="level">
        <div class="level-item has-text-centered">
          <div>
            <a v-bind:href="apiUrl + '/blog/mainpage'">Blog</a> 
          </div>
        </div>
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/apropos'">A propos</a> 
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/mentionlegale'">Mentions légales</a> 
            </div>
          </div>
          <div class="level-item has-text-centered">
            <div>
              <a v-bind:href="apiUrl + '/contact'">Contact</a> 
            </div>
          </div>
          <div class="level-item has-text-centered">
              <social-sharing url="https://expedijob.com"
                      title="Un nouveau site avec des offres d'emploi 100% télétravail"
                      description="Un site pour trouver un job en télétravail"
                      quote="Un nouveau site avec des offres d'emploi 100 % télétravail"
                      inline-template>
           
                <network network="twitter">
                  <font-awesome-icon :icon="[ 'fab', 'twitter-square' ]" size="3x" />
                </network>     
            
              </social-sharing>
          </div>
          <div class="level-item has-text-centered">
              <social-sharing url="https://expedijob.com"
                      title="Un nouveau site avec des offres d'emploi 100% télétravail"
                      description="Un site pour trouver un job en télétravail"
                      quote="Un nouveau site avec des offres d'emploi 100 % télétravail"
                      inline-template>   
        
                <network network="facebook">
                  <font-awesome-icon :icon="[ 'fab', 'facebook-square' ]" size="3x" />
                </network>
            
              </social-sharing>
          </div>
        </nav>  
    </footer>
  </div> 
  </div> 
</template> 

<script>
import axios from 'axios';
export default {
    data () {
            return {
              checkboxGroup: [],
              tablejobdisp: [],
              tablorigin: [],
              apiUrl : '',
              noresult: '',
              searchTerm: 'télétravail',
              loading: true,
              noselection: true,
              retourmessage: '',
              email: null
            }
    },
    methods: {
       sendMessage(payload) {
        var api_url = this.apiUrl;
        api_url += '/confirmes';
        axios.post(api_url, payload)
          .then(response => {
          this.retourmessage = response.data.messageretour;
          alert(this.retourmessage);
          }
          )
          .catch((error) => {
            console.log(error);
          });
      }, 
      async processForm () {
        if (!this.email) {
            alert("Merci de compléter le champ email");
        } else {
            await this.$recaptchaLoaded();

            this.$recaptcha("processform").then((token) => {
              const payload = {
                               email: this.email,
                               token: token
                               };
              this.sendMessage(payload);
            });
        }
      },
      getJobDisp () {
        this.noselection = false;
        var trim_findName;
        if (this.findName) {
          trim_findName = this.findName.trim();
        } else {
          trim_findName = this.findName;
        }
   
        var filtername = new RegExp(trim_findName, 'i');
        var jobCategory = this.checkboxGroup;
        this.tablejobdisp = this.tablorigin.filter(function(jobres) {
            if (jobCategory.length > 0) {
              if (jobCategory.includes(jobres.category) && (filtername.test(jobres.title) || filtername.test(jobres.description))) {
                return true;
              } else {
                return false;
              }
            } else {              
              if (filtername.test(jobres.title) || filtername.test(jobres.description)) {
                return true;
              } else {
                return false;
              }
            }
        }) 

        if (this.tablejobdisp.length == 0) {
            this.noresult = "yes";
        } else {
            this.noresult = "no";
        }    
      },
      getDataFromBackend () {
        var api_url = this.apiUrl;
        api_url += '/tablejob';
        axios.get(api_url)
        .then(response => {
          this.tablorigin = response.data.tablejob;
          this.tablejobdisp = this.tablorigin.slice(0,50);
          this.loading = false;
        })
        .catch(error => {
          console.log(error)
        })
      },
      matchName(current) {
      let reggie = new RegExp(this.searchTerm, "ig");
      let found = current.search(reggie) !== -1;
      return !found ? current : current.replace(reggie, '<b>' + this.searchTerm + '</b>');
      },
      surlinema(current) {
      current = '<div class="content is-large is-family-monospace has-text-light has-background-grey-light has-text-centered">' + current + '</div>';    
      return current;
      }
    }
    ,
    created () {
      this.getDataFromBackend();
      this.apiUrl = process.env.API_URL;
    }
  }
</script>

 <style scoped>

.pre-formatted {
  white-space: pre-wrap;
}

 </style>




// WEBPACK FOOTER //
// src/components/Home.vue